/** ກວດຮູບແບບຕົວເລກຈາກຄຳຕອບຟອມ (string → ຕົວເລກ, ຈຳກັດຮູບແບບໃຫ້ຊັດເຈນ) */

import type { FormFieldSettings } from "@/server/platform/db/schema/forms";

export type ParsedFormNumberAnswer =
  | { ok: true; n: number; trimmed: string }
  | { ok: false; code: "INVALID_NUMBER" | "NUMBER_NOT_INTEGER" };

export function parseFormNumberAnswer(
  raw: string,
  integerOnly: boolean,
): ParsedFormNumberAnswer {
  const trimmed = raw.trim();
  if (trimmed.length === 0) {
    return { ok: false, code: "INVALID_NUMBER" };
  }
  if (integerOnly) {
    if (!/^-?\d+$/.test(trimmed)) {
      return { ok: false, code: "NUMBER_NOT_INTEGER" };
    }
    const n = Number(trimmed);
    if (!Number.isFinite(n) || !Number.isInteger(n)) {
      return { ok: false, code: "INVALID_NUMBER" };
    }
    return { ok: true, n, trimmed };
  }
  if (!/^-?(?:\d+(?:\.\d*)?|\.\d+)$/.test(trimmed)) {
    return { ok: false, code: "INVALID_NUMBER" };
  }
  const n = Number(trimmed);
  if (!Number.isFinite(n)) {
    return { ok: false, code: "INVALID_NUMBER" };
  }
  return { ok: true, n, trimmed };
}

export function numberAnswerOutOfRange(
  n: number,
  min: number | undefined,
  max: number | undefined,
): boolean {
  if (min !== undefined && Number.isFinite(min) && n < min) return true;
  if (max !== undefined && Number.isFinite(max) && n > max) return true;
  return false;
}

/** ຂໍ້ຄວາມຜິດສຳລັບຕົວຊ່ວຍກວດຝັ່ງ public ກ່ອນສົ່ງ */
export function publicClientNumberFieldMessage(
  raw: string,
  settings: FormFieldSettings | null | undefined,
  required: boolean,
): string | null {
  const t = raw.trim();
  if (t.length === 0) {
    return required ? "ກະລຸນາກອກຂໍ້ມູນ" : null;
  }
  const st =
    settings && typeof settings === "object"
      ? (settings as FormFieldSettings)
      : undefined;
  const integerOnly = Boolean(st?.integerOnly);
  const parsed = parseFormNumberAnswer(raw, integerOnly);
  if (!parsed.ok) {
    return parsed.code === "NUMBER_NOT_INTEGER"
      ? "ຮັບສະເພາະຈຳນວນເຕັມເທົ່ານັ້ນ"
      : "ກະລຸນາປ້ອນຕົວເລກທີ່ຖືກຕ້ອງ";
  }
  const min =
    typeof st?.min === "number" && Number.isFinite(st.min) ? st.min : undefined;
  const max =
    typeof st?.max === "number" && Number.isFinite(st.max) ? st.max : undefined;
  if (numberAnswerOutOfRange(parsed.n, min, max)) {
    return "ຄ່າຢູ່ນອກຊ່ວງທີ່ອະນຸຍາດ";
  }
  return null;
}
